import React, { memo } from 'react';
import { Box, Typography, ButtonBase } from '@material-ui/core';
import { Link, useParams } from 'react-router-dom';

import CertificateIcon from '../../../../components/icons/CertificateIcon';
import useStyles from './styles';

const Certificate = props => {
  const classes = useStyles();
  const { isActive } = props;
  const { course: courseId } = useParams();

  // React.useEffect(() => {
  //   if (pathname.split('/').pop() === 'certificate') {

  //   }
  // }, [pathname]);

  return (
    <ButtonBase
      component={Link}
      to={`/course/${courseId}/certificate`}
      className={`${classes.container} ${isActive ? 'active' : ''}`}
    >
      <Box className="title">
        <Typography className="title-text" variant="caption">
          Certificado
        </Typography>
      </Box>
      <Box className="icon">
        <CertificateIcon fontSize="small" color="inherit" />
      </Box>
    </ButtonBase>
  );
};

export default memo(Certificate);
